import { useReactiveVar } from '@apollo/client';
import {
    paymentMethodVar, promocodeVar, selectedPeriodVar, subscriptionTypeVar,
} from 'app/apollo/reaction';
import { billingVarByMethodAndType } from 'app/containers/BasketResolver';

type BillingMutationVarsType = {
    promocode: string,
    period: string,
    payment_method: 'sbp' | 'online' | 'recurrent',
};

export function useBillingMutationVars(): BillingMutationVarsType {
    const type = useReactiveVar(subscriptionTypeVar);
    const period = useReactiveVar(selectedPeriodVar);
    const method = useReactiveVar(paymentMethodVar);
    const promocode = useReactiveVar(promocodeVar);

    // useEffect(() => {
    //     console.log(`Updated: ${type}, ${method}`);
    // }, [type, method]);

    return {
        promocode,
        period,
        payment_method: billingVarByMethodAndType(type, method),
    };
}
